<template>
  <div>
    <resign-modal v-if="resign.isTerminating"
                  :representative="resign.representative"
                  :resign="resign.handler"
                  @cancel="resign.isTerminating = false">
    </resign-modal>

    <mainify-modal v-if="mainify.showModal"
                   :new-main-representative="mainify.representative"
                   :previous-representative="mainRepresentative"
                   :form="representativeManificationForm"
                   @mainify="sendMainify">

    </mainify-modal>

    <div class="tab-pane slide-left active">
      <div class="row column-seperation">
        <div class="col-md-12"
             v-if="newRepresentativeEditing">
          <div class="title">
            <h3>Ajout d'un Représentant légal</h3>
            <button class="btn btn-danger"
                    @click="newRepresentativeEditing = false">Annuler</button>
          </div>
          <resource-form :model="newRepresentativeForm.model"
                         :schema="newRepresentativeForm.schema"
                         :triggers="newRepresentativeForm.triggers"
                         @submit="addRepresentative">
          </resource-form>
        </div>
        <template v-if="!newRepresentativeEditing">
          <div class="col-md-12">
            <div class="title">
              <h3 v-if="mainRepresentative">Représentant légal principal</h3>
              <h3 v-else>Pas de représentants légaux</h3>
              <button v-if="mainRepresentativeEditing"
                      class="btn btn-danger"
                      @click="mainRepresentativeEditing = false">Annuler</button>
              <button v-else
                      class="btn btn-complete"
                      @click="prepareNewRepresentativeForm">Ajouter un représentant</button>
            </div>
            <main-representative v-if="representatives.length"
                                 :representative="mainRepresentative"
                                 :form="mainRepresentativeForm"
                                 :editing="mainRepresentativeEditing"
                                 :is-prospect="isProspect"
                                 @edit="prepareRepresentativeEdition($event)"
                                 @edit-info="prepareRepresentativeInfoEdition($event)"
                                 @edit-address="prepareRepresentativeAddressEdition($event)"
                                 @finish-edit="handleRepresentativeEdition"
                                 @remove="removeRepresentative"
                                 @terminate="terminateRepresentative">
            </main-representative>
          </div>
          <div class="col-md-12"
               v-if="otherRepresentatives.length && otherRepresentativesEditing.length">
            <h3>Autres représentants légaux</h3>
            <other-representatives v-for="(representative, idx) in otherRepresentatives"
                                   :key="'other-representative-'+idx"
                                   :representative="representative"
                                   :editing="otherRepresentativesEditing[idx]"
                                   :is-prospect="isProspect"
                                   :form="otherRepresentativesForm[idx]"
                                   @edit="prepareRepresentativeEdition($event, idx)"
                                   @edit-info="prepareRepresentativeInfoEdition($event, idx)"
                                   @edit-address="prepareRepresentativeAddressEdition($event, idx)"
                                   @cancel-edit="cancelRepresentativeEdition(idx)"
                                   @finish-edit="otherRepresentativesEditingHandlers[idx]"
                                   @remove="removeRepresentative"
                                   @terminate="handleTermination($event, idx)"
                                   @show-mainify="switchMainifyModal(representative)">

            </other-representatives>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script type="text/babel">
  import MainRepresentative from 'components/Customer/RepresentativesContent/MainRepresentative'
  import OtherRepresentatives from 'components/Customer/RepresentativesContent/OtherRepresentatives'
  import ResourceForm from "components/Forms/ResourceForm"

  import ResignModal from './RepresentativesContent/ResignModal'
  import MainifyModal from './RepresentativesContent/MainifyModal'
  // import Select2 from '../Form/Select2'

  import { mapState, mapActions, mapGetters } from 'vuex'

  const _FormSchemaStructure = () => ({
    model: {},
    schema: {
      fields: [],
      optional_fields: []
    },
    triggers: {}
  })

  export default {

    name: 'Representatives',

    components: {
      MainRepresentative,
      OtherRepresentatives,
      ResourceForm,
      ResignModal,
      MainifyModal,
    },

    data () {
      return {
        mainRepresentativeForm: {},
        mainRepresentativeEditing: false,
        otherRepresentativesForm: [],
        otherRepresentativesEditing: [],
        otherRepresentativesEditingHandlers: [],
        // otherRepresentativesTerminationHandlers: {},
        mainify: {
          showModal: false,
          representative: null,
        },
        newRepresentativeForm: {},
        newRepresentativeEditing: false,
        unwatchRepresentatives: null,
        resign: {
          isTerminating: false,
          representative: {},
          handler: null,
        },
      }
    },

    beforeDestroy () {
      _.isNull(this.unwatchRepresentatives) || this.unwatchRepresentatives()
    },

    created () {
      this.unwatchRepresentatives = this.$watch(
        function () { return this.otherRepresentatives },
        function (rep, oldRep) {
          if (_.isEqual(rep, oldRep))
            return;
          const newForms = _.map(
            rep,
            () => _.assign({}, _FormSchemaStructure())
          ),
            newEditingFlags = _.map(rep, () => false),
            newHandlers = _.map(
              rep,
              (rep, idx) => this.prepareOtherRepresentativeHandler(idx)
            )

          this.otherRepresentativesForm.splice(0, this.otherRepresentativesForm.length, ...newForms)
          this.otherRepresentativesEditing.splice(0, this.otherRepresentativesEditing.length, ...newEditingFlags)
          this.otherRepresentativesEditingHandlers.splice(0, this.otherRepresentativesEditingHandlers.length, ...newHandlers)
          // this.otherRepresentativesTerminationHandlers = _.map(
          //   this.otherRepresentatives,
          //   (rep, idx) => this.prepareTerminationHandler(idx)
          // )
        }, {
          immediate: true
        }
      )
    },

    computed: {
      ...mapState('customer', [
        'representatives',
        'id',
        'representativeManificationForm',
        'validation_requests'
      ]),

      ...mapGetters('customer', [
        'isProspect'
      ]),

      mainRepresentative () {
        return _.find(this.representatives, ['person.representative_main', true])
        //return this.filter(this.representatives, (rep) => rep.person.representative_main)
      },

      otherRepresentatives () {
        // return _.filter(this.representatives, [ 'person.representative_main', false ])
        return this.representatives.filter((rep) => !(_.has(rep.person, 'representative_main') && rep.person.representative_main))
      },

      editingState () {
        return this.mainRepresentativeEditing || _.some(this.otherRepresentativesEditing, (ed) => ed)
      }
    },

    methods: {
      ...mapActions('customer', [
        'fetchCustomer',
        'fetchRepresentatives',
        'updateRepresentative',
        'updateRepresentativeInfo',
        'updateRepresentativeAddress',
        'addRepresentative',
        'terminateRepresentative',
        'mainifyRepresentative',
        'fetchRepresentativeMainificationForm'
      ]),

      cancelRepresentativeEdition (idx) {
        this.$set(this.otherRepresentativesEditing, idx, false)
      },

      editRepresentative (representativeId) {
        return this.axios.get(`customers/${this.id}/representatives/${representativeId}/edit`)
      },

      editRepresentativeInfo (representativeId) {
        return this.axios.get(`customers/${this.id}/representatives/${representativeId}/edit_info`)
      },

      editRepresentativeAddress (representativeId) {
        return this.axios.get(`customers/${this.id}/representatives/${representativeId}/edit_address`)
      },

      createRepresentative () {
        return this.axios.get(`customers/${this.id}/representatives/create`)
      },

      handleTermination (rep, idx) {
        //        debugger
        this.resign.representative = _.assign({}, this.otherRepresentatives[idx], rep)
        this.resign.handler = (repr) => {
          this.terminateRepresentative(repr)
            .then(() => {
              this.resign.isTerminating = false
              this.resign.representative = {}
            })
        }
        this.resign.isTerminating = true
      },

      prepareTerminationHandler (idx) {
        return _.partialRight(this.handleTermination, idx)
      },

      prepareRepresentativeEdition (representativeId, idx = false) {
        this.editRepresentative(representativeId)
          .then(response => {
            const isMain = idx === false,
              { form } = response.data
            if (isMain) {
              this.mainRepresentativeForm = _.assign({}, form)
              this.mainRepresentativeEditing = true
            } else {
              this.$set(this.otherRepresentativesForm, idx, form)
              this.otherRepresentativesEditing[idx] = true
            }
          })
      },

      prepareRepresentativeInfoEdition (representativeId, idx = false) {
        this.editRepresentativeInfo(representativeId)
          .then(response => {
            const isMain = idx === false,
              { form } = response.data
            if (isMain) {
              this.mainRepresentativeForm = _.assign({}, form)
              this.mainRepresentativeEditing = true
            } else {
              this.$set(this.otherRepresentativesForm, idx, form)
              this.$set(this.otherRepresentativesEditing, idx, true)
            }
          })
      },

      prepareRepresentativeAddressEdition (representativeId, idx = false) {
        var vm = this
        this.editRepresentativeAddress(representativeId)
          .then(function (response) {
            const isMain = idx === false,
              { form } = response.data
            if (isMain) {
              vm.mainRepresentativeForm = _.assign({}, form)
              vm.mainRepresentativeEditing = true
            } else {
              vm.$set(vm.otherRepresentativesForm, idx, form)
              vm.$set(vm.otherRepresentativesEditing, idx, true)
            }
          })
      },

      prepareNewRepresentativeForm () {
        this.createRepresentative()
          .then(response => {
            let { form } = response.data

            this.newRepresentativeForm = _.assign({}, form)
            this.newRepresentativeForm.model.person.moral_person = false
            this.newRepresentativeEditing = true
          })
      },

      determineUpdateFunction (type) {
        return _.isNull(type) ?
          this.updateRepresentative :
          type === 'info' ?
            this.updateRepresentativeInfo :
            this.updateRepresentativeAddress
      },

      handleRepresentativeEdition ($event, type = null, idx = false) {

        const model = $event.data,
          update = this.determineUpdateFunction(type)

        model.validation_override = __REQUESTS_VALIDATION_OVERRIDE__
        update(model)
          .then(response => {
            const isMain = idx === false
            // debugger
            if (isMain) {
              this.mainRepresentativeEditing = false
            } else {
              this.otherRepresentativesEditing[idx] = false
            }
          })
      },

      prepareOtherRepresentativeHandler (idx) {
        return _.partialRight(this.handleRepresentativeEdition, idx)
      },

      addRepresentative ($event) {
        const model = $event.data
        model.validation_override = __REQUESTS_VALIDATION_OVERRIDE__
        model.person.moral_person = model.person.hasOwnProperty('moral_person') ?
          model.person.moral_person :
          false
        this.axios.post(`customers/${this.id}/representatives`, model)
          .then(response => {
            this.newRepresentativeEditing = false
            this.fetchCustomer(this.$route.params.id)
            this.fetchRepresentatives()
          })
      },

      removeRepresentative (id) {
        this.axios.delete(`customers/${this.id}/representatives/${id}`)
          .then(response => this.fetchRepresentatives())
      },

      switchMainifyModal (representative) {
        this.fetchRepresentativeMainificationForm(representative.representative_id)
          .then(() => {

            this.mainify.representative = representative
            this.mainify.showModal = !this.mainify.showModal
            // this.sendMainify()
          })

      },

      sendMainify (representativeId, payload) {
        this.mainifyRepresentative({ representativeId, payload })
      }
    },

  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/Representatives.vue